import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";
import * as MyStorage from "../../helpers/myStorage";
import { getServiceList } from "../../services/service.service";

export const loginAsync = createAsyncThunk(
  "user/login",
  async (credentials, { rejectWithValue }) => {
    try {
      MyStorage.AppCache.setConnections(null);
      MyStorage.AppCache.setSelectedConnection(null);
      let { connectionCode } = credentials;
      const { jwt, connectionList } = await AuthService.doLogin(credentials);

      MyStorage.AppCache.setApplicationJwt(jwt);
      const userProfile = await AuthService.getUserProfile();
      MyStorage.AppCache.setUserProfile(userProfile);
      if (connectionList !== null) {
        MyStorage.AppCache.setConnections(connectionList);
        if (connectionList.length === 1) {
          MyStorage.AppCache.setSelectedConnection(connectionList[0]);

          if (connectionList[0].nodeList.length === 1) {
            const node = connectionList[0].nodeList[0];
            MyStorage.AppCache.setSelectedConnectionNode(node);

            const serviceList = await getServiceList({
              connectionCode: connectionCode,
              nodeCode: node.code,
            });
            MyStorage.AppCache.setServicelist(serviceList);
          }
        }
      }

      return {
        token: jwt,
        user: { ...userProfile, connectionCode: connectionCode },
      };
    } catch (err) {
      console.log(err)
      switch (err.code) {
        case 1302:
          return rejectWithValue("User Not Found");
        case 1301:
          return rejectWithValue("Username or password is incorrect");
        case 5002:
          return rejectWithValue("Record not found!");
        default:
          return rejectWithValue(err.error.message.toString());
      }
    }
  }
);

export const logoutAsync = createAsyncThunk(
  "user/logout",
  async (isSessionExpired = null) => {
    try {
      await AuthService.doLogout();       
      MyStorage.AppCache.onLoggout();
    } catch (err) {
      //
    }
    return isSessionExpired;
  }
);

const initialState = {
  loading: false,
  isLoggedIn: MyStorage.AppCache.getUserProfile() ? true : false,
  userInfo: MyStorage.AppCache.getUserProfile(),
  accessToken: MyStorage.AppCache.getApplicationJwt(),
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginError(state, action) {
      state.error = action.payload;
    },
    removeError(state) {
      state.error = null;
    },
    setExpired(state, action) {
      state.sessionExpired = action.payload || false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        let { token, user, expireIn } = action.payload;
        state.loading = false;
        state.isLoggedIn = true;
        state.userInfo = user;
        state.accessToken = token;
        state.expireIn = expireIn;
        state.sessionExpired = null;
      })
      .addCase(loginAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logoutAsync.fulfilled, (state, action) => {
        state.isLoggedIn = false;
        state.userInfo = {};
        state.accessToken = null;
        state.expireIn = 0;
        state.sessionExpired = action.payload;
      });
  },
});

export const { loginError, removeError, setExpired } = authSlice.actions;
export default authSlice.reducer;


// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import AuthService from "../../services/auth.service";
// import * as MyStorage from "../../helpers/myStorage";
// import { getServiceList } from "../../services/service.service";

// // Kullanışlı destructuring
// const {
//   setConnections,
//   setSelectedConnection,
//   setSelectedConnectionNode,
//   setApplicationJwt,
//   setUserProfile,
//   setServicelist,
//   onLoggout,
//   getUserProfile,
//   getApplicationJwt,
// } = MyStorage.AppCache;

// export const loginAsync = createAsyncThunk(
//   "user/login",
//   async (credentials, { rejectWithValue, dispatch }) => {
//     try {
//       setConnections(null);
//       setSelectedConnection(null);

//       const { connectionCode } = credentials;
//       const { jwt, connectionList } = await AuthService.doLogin(credentials);

//       setApplicationJwt(jwt);

//       const userProfile = await AuthService.getUserProfile();
//       setUserProfile(userProfile);

//       if (connectionList !== null) {
//         setConnections(connectionList);

//         if (connectionList.length === 1) {
//           setSelectedConnection(connectionList[0]);

//           if (connectionList[0].nodeList.length === 1) {
//             const node = connectionList[0].nodeList[0];
//             setSelectedConnectionNode(node);

//             const serviceList = await getServiceList({
//               connectionCode,
//               nodeCode: node.code,
//             });
//             setServicelist(serviceList);
//           }
//         }
//       }

//       return {
//         token: jwt,
//         user: { ...userProfile, connectionCode },
//         // expireIn: jwt?.expireIn || 3600, // Uncomment if needed
//       };
//     } catch (err) {
//       console.error("Login error:", err);

//       if (err.response) {
//         const resData = err.response.data;
//         if (resData && resData.error && resData.error.message) {
//           return rejectWithValue(resData.error.message);
//         }
//         return rejectWithValue(resData || "Unknown server error");
//       }

//       if (err.code) {
//         switch (err.code) {
//           case 1302:
//             return rejectWithValue("User Not Found");
//           case 1301:
//             return rejectWithValue("Username or password is incorrect");
//           case 5002:
//             return rejectWithValue("Record not found!");
//           default:
//             return rejectWithValue(
//               err?.error?.message?.toString() || err?.message || "An unknown error occurred."
//             );
//         }
//       }
//     }
//   }
// );

// export const logoutAsync = createAsyncThunk(
//   "user/logout",
//   async (isSessionExpired = null) => {
//     try {
//       await AuthService.doLogout();
//       onLoggout();
//     } catch (err) {
//       console.warn("Logout error:", err);
//     }

//     return isSessionExpired;
//   }
// );

// const initialState = {
//   loading: false,
//   isLoggedIn: getUserProfile() ? true : false,
//   userInfo: getUserProfile(),
//   accessToken: getApplicationJwt(),
//   error: null,
//   expireIn: 0,
//   sessionExpired: null,
// };

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     loginError(state, action) {
//       state.error = action.payload;
//     },
//     removeError(state) {
//       state.error = null;
//     },
//     setExpired(state, action) {
//       state.sessionExpired = action.payload || false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(loginAsync.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(loginAsync.fulfilled, (state, action) => {
//         const payload = action.payload || {};
//         const { token, user, expireIn } = payload;

//         state.loading = false;
//         state.isLoggedIn = true;
//         state.userInfo = user || {};
//         state.accessToken = token || null;
//         state.expireIn = expireIn || 0;
//         state.sessionExpired = null;
//       })

//   },
// });

// export const { loginError, removeError, setExpired } = authSlice.actions;
// export default authSlice.reducer;
